/**
 * Canned responses resource — saved replies (parity). List/get is open to agents;
 * create/update/delete are admin-gated server-side.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { CannedResponse, CannedResponseInput } from '../../types';

export class CannedResponsesResource {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<CannedResponse[]> {
    return this.http.get(endpoints.cannedResponses.list());
  }

  create(body: CannedResponseInput): Promise<CannedResponse> {
    return this.http.post(endpoints.cannedResponses.create(), body);
  }

  update(id: string, patch: Partial<CannedResponseInput>): Promise<CannedResponse> {
    return this.http.patch(endpoints.cannedResponses.detail(id), patch);
  }

  remove(id: string): Promise<void> {
    return this.http.delete(endpoints.cannedResponses.detail(id));
  }
}
